module.exports = __webpack_public_path__ + "img/sceneIcon2-2.fae481a8.png";